module.exports = __webpack_public_path__ + "img/vivo2.583a8ad8.png";